import ProductCURModule from "@/modules/SiteProductCUR";

function SiteProductEditPage() {
  return <ProductCURModule type="edit" />;
}

export default SiteProductEditPage;
